/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { def_0 } from '../models/def_0';
import type { def_1 } from '../models/def_1';
import type { def_2 } from '../models/def_2';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class LookupAPI {

  /**
   * Method that returns a list of access levels
   * @param offset
   * @param limit
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiRoleList(
    offset?: number,
    limit?: number,
  ): CancelablePromise<Array<{
    id: number;
    level: string;
    name: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/role/list',
      query: {
        'offset': offset,
        'limit': limit,
      },
    });
  }

  /**
   * Method that returns a list of auction types
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiAuctionTypeList(): CancelablePromise<Array<{
    id: number;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/auction/type/list',
    });
  }

  /**
   * Method that returns a list of browser
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiBrowserList(): CancelablePromise<Array<{
    id: number;
    browser: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/browser/list',
    });
  }

  /**
   * Method that returns a list of cities
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param country
   * @param state
   * @param name
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCityList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    country?: string,
    state?: string,
    name?: Array<string>,
  ): CancelablePromise<Array<{
    id: number;
    country: string;
    state: string;
    name: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/city/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'country': country,
        'state': state,
        'name': name,
      },
    });
  }

  /**
   * Method that returns a count of cities
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param country
   * @param state
   * @param name
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCityCount(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    country?: string,
    state?: string,
    name?: Array<string>,
  ): CancelablePromise<{
    count: number;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/city/count',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'country': country,
        'state': state,
        'name': name,
      },
    });
  }

  /**
   * Method that returns a list of connectors
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiConnectorList(): CancelablePromise<Array<{
    id: number;
    name: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/connector/list',
    });
  }

  /**
   * Method that returns a list of content types
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiContentTypeList(): CancelablePromise<Array<{
    id: number;
    content_type: string;
    allowed_for_site: boolean;
    allowed_for_network: boolean;
    allowed_for_background: boolean;
    available: boolean;
    is_public: boolean;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/content/type/list',
    });
  }

  /**
   * Method that returns a list of countries
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param alpha3
   * @param name
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCountryList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: Array<string>,
    alpha3?: string,
    name?: string,
  ): CancelablePromise<Array<{
    id: string;
    name: string;
    alpha3: string | null;
    latitude: number;
    longitude: number;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/country/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'alpha3': alpha3,
        'name': name,
      },
    });
  }

  /**
   * Method that returns a list of countries from a shape
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param alpha3
   * @param name
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCountryList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: Array<string>,
    alpha3?: string,
    name?: string,
    requestBody?: (def_0 | def_1 | def_2),
  ): CancelablePromise<Array<{
    id: string;
    name: string;
    alpha3: string | null;
    latitude: number;
    longitude: number;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/country/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'alpha3': alpha3,
        'name': name,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a count of countries
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param alpha3
   * @param name
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCountryCount(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: Array<string>,
    alpha3?: string,
    name?: string,
  ): CancelablePromise<{
    count: number;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/country/count',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'alpha3': alpha3,
        'name': name,
      },
    });
  }

  /**
   * Method that returns a list of events
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiEventList(): CancelablePromise<Array<{
    id: number;
    name: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/event/list',
    });
  }

  /**
   * Method that returns a list of geography presets
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiGeographyPresetList(): CancelablePromise<Array<{
    id: number;
    name: string | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/geography/preset/list',
    });
  }

  /**
   * Method that returns a list of ISPs
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiIspList(): CancelablePromise<Array<{
    id: number;
    name: string | null;
    pattern: string | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/isp/list',
    });
  }

  /**
   * Method that returns a list of languages
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiLanguageList(): CancelablePromise<Array<{
    id: string;
    language: string | null;
    is_translated: boolean;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/language/list',
    });
  }

  /**
   * Method that returns a list of networks
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiNetworkList(): CancelablePromise<Array<{
    id: number;
    name: string;
    network_tag_id: number | null;
    platform_id: number;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/network/list',
    });
  }

  /**
   * Method that returns a list of OSes
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiOsList(): CancelablePromise<Array<{
    id: number;
    name: string;
    header_string: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/os/list',
    });
  }

  /**
   * Method that returns a list of platforms
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiPlatformList(): CancelablePromise<Array<{
    id: number;
    name: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/platform/list',
    });
  }

  /**
   * Method that returns a list of priorities
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiPriorityList(): CancelablePromise<Array<{
    id: number;
    chain: string;
    level: number;
    is_public: boolean;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/priority/list',
    });
  }

  /**
   * Method that returns a list of states
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param countryId
   * @param name
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiStateList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: Array<string>,
    countryId?: Array<string>,
    name?: string | null,
  ): CancelablePromise<Array<{
    country_id: string;
    id: string;
    name: string | null;
    latitude: number;
    longitude: number;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/state/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'country_id': countryId,
        'name': name,
      },
    });
  }

  /**
   * Method that returns a list of states from a shape
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param countryId
   * @param name
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiStateList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: Array<string>,
    countryId?: Array<string>,
    name?: string | null,
    requestBody?: (def_0 | def_1 | def_2),
  ): CancelablePromise<Array<{
    country_id: string;
    id: string;
    name: string | null;
    latitude: number;
    longitude: number;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/state/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'country_id': countryId,
        'name': name,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a count of states
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @param countryId
   * @param name
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiStateCount(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: Array<string>,
    countryId?: Array<string>,
    name?: string | null,
  ): CancelablePromise<{
    count: number;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/state/count',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
        'country_id': countryId,
        'name': name,
      },
    });
  }

  /**
   * Method that returns a list of targeting levels
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiTargetingLevelList(): CancelablePromise<Array<{
    id: number;
    name: string;
    is_public: boolean;
    priority: {
      id: number;
      level: number;
    };
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/targeting/level/list',
    });
  }

  /**
   * Method that returns possible VAST versions
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiVastVersionList(): CancelablePromise<Array<{
    id: number;
    name: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/vast/version/list',
    });
  }

  /**
   * Method that returns a list of possible weather
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiWeatherList(): CancelablePromise<Array<{
    id: number;
    name: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/weather/list',
    });
  }

  /**
   * Method that returns a list of postal codes
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param countryId
   * @param stateId
   * @param postalCode
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiPostalCodeShapeList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    countryId?: string,
    stateId?: string,
    postalCode?: Array<string>,
  ): CancelablePromise<Array<{
    id: number;
    country_id: string;
    postal_code: string;
    latitude: number;
    longitude: number;
    state_id: string;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/postal_code_shape/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'country_id': countryId,
        'state_id': stateId,
        'postal_code': postalCode,
      },
    });
  }

  /**
   * Method that returns a list of postal codes from a shape
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param countryId
   * @param stateId
   * @param postalCode
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiPostalCodeShapeList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    countryId?: string,
    stateId?: string,
    postalCode?: Array<string>,
    requestBody?: (def_0 | def_1 | def_2),
  ): CancelablePromise<Array<{
    id: number;
    country_id: string;
    postal_code: string;
    latitude: number;
    longitude: number;
    state_id: string;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/postal_code_shape/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'country_id': countryId,
        'state_id': stateId,
        'postal_code': postalCode,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a count of postal codes
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param countryId
   * @param stateId
   * @param postalCode
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiPostalCodeShapeCount(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    countryId?: string,
    stateId?: string,
    postalCode?: Array<string>,
  ): CancelablePromise<{
    count: number;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/postal_code_shape/count',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'country_id': countryId,
        'state_id': stateId,
        'postal_code': postalCode,
      },
    });
  }

  /**
   * Method that returns a particular postal_code and its shape from a postal_code_shape id
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiPostalCodeShape(
    id: number,
  ): CancelablePromise<{
    id: number;
    country_id: string;
    postal_code: string;
    latitude: number;
    longitude: number;
    state_id: string;
    shape?: (def_0 | def_1 | def_2);
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/postal_code_shape/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a list of venue types
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiVenueTypeList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    id?: Array<number>,
  ): CancelablePromise<Array<{
    id: number;
    ssp_id: number | null;
    name: string;
    description: string;
    openrtb3_code: number | null;
    openooh_code: number | null;
    dmi_code: string | null;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/venue_type/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'id': id,
      },
    });
  }

  /**
   * Method that returns a list of timezone in
   * @returns string Default Response
   * @throws ApiError
   */
  public static getApiTimezoneList(): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/timezone/list',
    });
  }

  /**
   * Method that returns a list of city shapes
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param countryId
   * @param stateId
   * @param name
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCityShapeList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    countryId?: string,
    stateId?: string,
    name?: Array<string>,
  ): CancelablePromise<Array<{
    id: number;
    country_id: string;
    state_id: string;
    external_id: string;
    classification: string;
    name: string;
    area: number;
    longitude: number;
    latitude: number;
  }>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/city_shape/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'country_id': countryId,
        'state_id': stateId,
        'name': name,
      },
    });
  }

  /**
   * Method that returns a list of cities from a shape
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param countryId
   * @param stateId
   * @param name
   * @param requestBody
   * @returns any Default Response
   * @throws ApiError
   */
  public static postApiCityShapeList(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    countryId?: string,
    stateId?: string,
    name?: Array<string>,
    requestBody?: (def_0 | def_1 | def_2),
  ): CancelablePromise<Array<{
    id: number;
    country_id: string;
    state_id: string;
    external_id: string;
    classification: string;
    name: string;
    area: number;
    longitude: number;
    latitude: number;
  }>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/city_shape/list',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'country_id': countryId,
        'state_id': stateId,
        'name': name,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Method that returns a count of city shapes
   * @param offset
   * @param limit
   * @param search
   * @param match
   * @param orderby
   * @param comparator
   * @param countryId
   * @param stateId
   * @param name
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCityShapeCount(
    offset?: number,
    limit?: number,
    search?: string,
    match: 'exact' | 'contains' | 'starts_with' | 'ends_with' | 'not' = 'starts_with',
    orderby?: Array<string>,
    comparator?: Array<string>,
    countryId?: string,
    stateId?: string,
    name?: Array<string>,
  ): CancelablePromise<{
    count: number;
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/city_shape/count',
      query: {
        'offset': offset,
        'limit': limit,
        'search': search,
        'match': match,
        'orderby': orderby,
        'comparator': comparator,
        'country_id': countryId,
        'state_id': stateId,
        'name': name,
      },
    });
  }

  /**
   * Method that returns a particular city and its shape from a city_shape id
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCityShape(
    id: number,
  ): CancelablePromise<{
    id: number;
    country_id: string;
    state_id: string;
    external_id: string;
    classification: string;
    name: string;
    area: number;
    longitude: number;
    latitude: number;
    shape?: (def_0 | def_1 | def_2);
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/city_shape/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a particular country and its shape from a country id
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiCountryShape(
    id: string,
  ): CancelablePromise<{
    id: string;
    name: string;
    alpha3: string | null;
    latitude: number;
    longitude: number;
    shape?: (def_0 | def_1 | def_2);
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/country_shape/{id}',
      path: {
        'id': id,
      },
    });
  }

  /**
   * Method that returns a particular state and its shape from a state id
   * @param id
   * @returns any Default Response
   * @throws ApiError
   */
  public static getApiStateShape(
    id: string,
  ): CancelablePromise<{
    country_id: string;
    id: string;
    name: string | null;
    latitude: number;
    longitude: number;
    shape?: (def_0 | def_1 | def_2);
  }> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/state_shape/{id}',
      path: {
        'id': id,
      },
    });
  }

}
